// Iter206 — Loader lazy per opencv.js + jscanify (usati dallo Scanner)
// Non aggiungiamo dipendenza npm perché opencv.js è pesante (~10MB) e ne
// serve caricamento solo on-demand.

let _cvPromise = null;
let _scannerPromise = null;

// Carica opencv.js una sola volta. Espone `window.cv` quando pronto.
export function loadOpenCV() {
  if (typeof window === "undefined") return Promise.reject(new Error("no window"));
  if (window.cv && window.cv.imread) return Promise.resolve(window.cv);
  if (_cvPromise) return _cvPromise;
  _cvPromise = new Promise((resolve, reject) => {
    const timeoutMs = 30000;
    const timer = setTimeout(() => reject(new Error("opencv.js timeout")), timeoutMs);
    // opencv.js chiama window.Module.onRuntimeInitialized quando pronto
    window.Module = window.Module || {};
    const prevInit = window.Module.onRuntimeInitialized;
    window.Module.onRuntimeInitialized = () => {
      try { prevInit && prevInit(); } catch (_) {}
      clearTimeout(timer);
      if (window.cv && window.cv.imread) resolve(window.cv);
      else reject(new Error("opencv.js loaded but cv missing"));
    };
    if (document.querySelector('script[data-opencv-loader="1"]')) return;
    const s = document.createElement("script");
    s.src = "https://docs.opencv.org/4.10.0/opencv.js";
    s.async = true;
    s.dataset.opencvLoader = "1";
    s.onerror = () => { clearTimeout(timer); reject(new Error("opencv.js load error")); };
    document.head.appendChild(s);
  });
  return _cvPromise;
}

// Carica jscanify (usa opencv.js). Espone `window.jscanify`.
export function loadJscanify() {
  if (typeof window === "undefined") return Promise.reject(new Error("no window"));
  if (window.jscanify) return Promise.resolve(window.jscanify);
  if (_scannerPromise) return _scannerPromise;
  _scannerPromise = (async () => {
    await loadOpenCV();
    if (window.jscanify) return window.jscanify;
    return await new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = "https://cdn.jsdelivr.net/gh/puffinsoft/jscanify@master/src/jscanify.min.js";
      s.async = true;
      s.onload = () => resolve(window.jscanify);
      s.onerror = () => reject(new Error("jscanify load error"));
      document.head.appendChild(s);
    });
  })();
  return _scannerPromise;
}
